<div class="grid-2col input-grid-gaps">
    <app-date-input [formField]="formDef.period" view="month" dateFormat="mm/yy" [label]="prefix + 'period'"></app-date-input>
    <app-select-input [formField]="formDef.serviceId" [staticOptions]="serviceOptions" [label]="prefix + 'service'"></app-select-input>
    @if (basis) {
        <app-number-input [formField]="formDef.manualNetAmount" [minFractionDigits]="2" [maxFractionDigits]="2" [label]="prefix + 'manualNetAmount'"></app-number-input>
        <div>{{ prefix + 'manualNetAmountHelp' | translate }}</div>
    }
</div>
